const defaultValue = true;

const isSideContentOpen = (state = defaultValue, action) => {
  switch (action.type) {
    case "OPEN_SIDE_CONTENT":
      return true;
    case "CLOSE_SIDE_CONTENT":
      return false;
    default:
      return state;
  }
};

export default isSideContentOpen;
